module.exports = __webpack_public_path__ + "img/fuli.9fd4d0c4.png";